(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/core/assets/javascripts/playable-amount-dialog.js') >= 0) return;  svs.modules.push('/components/syndicate/core/assets/javascripts/playable-amount-dialog.js');
"use strict";


const showPlayableAmountDialog = attachedTo => {
  const dialog = new svs.ui.dialog.Contextual({
    branding: svs.ui.dialog.branding.TUR,
    attachTo: attachedTo,
    title: 'Spelbart saldo i laget',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Ditt lags spelbara saldo räknas ut genom att ta saldot från medlemmen med lägst saldo gånger antalet aktiva medlemmar plus eventuellt saldo i avrundningskontot för laget.'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
setGlobal('svs.syndicate.core.showPlayableAmountDialog', showPlayableAmountDialog);

 })(window);